/**
 * Lo que el plan del club no incluye · `endpoints.md` §A.2.1
 *
 * Una pantalla que **explica**, no un error: el servidor respondería
 * `403 plan_feature_missing`, y enseñar eso como un fallo haría pensar que algo
 * está roto cuando lo que pasa es que no está contratado.
 *
 * Solo se pinta cuando el plan ya se ha cargado y dice que no: mientras carga, la
 * sección se enseña (ver `tieneFuncion`).
 */
import { Vacio } from '@/shared/ui/Estados';
import { useContextoDelClub } from '@/club/contexto';
import { comoConseguirla, type FuncionDelPlan } from '@/club/plan';

const TITULO: Record<FuncionDelPlan, string> = {
  campeonatos: 'Los campeonatos no están en vuestro plan',
  roles: 'Los administrativos y ayudantes no están en vuestro plan',
  multisede: 'Limitar entrenadores por sede no está en vuestro plan',
  benchmarking: 'La comparación con otros clubes no está en vuestro plan',
};

export function NoIncluido({ funcion }: { funcion: FuncionDelPlan }) {
  const { plan } = useContextoDelClub();
  return (
    <Vacio
      titulo={TITULO[funcion]}
      explicacion={comoConseguirla(plan, funcion)}
    />
  );
}
